import React from 'react';
import { Row, Col, Space, Typography, Avatar, Divider, Image, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import CButton from '../../../../../components/Button'
import moment from 'moment';

const { Text } = Typography;

export default function CareerPathwayDetailEditProfile(props) {
  const { 
    t, 
    state: {
      onPreviewAvatar,
      callingCode,
      location,
      educationLevelName,
      workLocation,
      businessSectorName,
      documentFile,
      documentTypeName,
      allValues,
      submitLoading
    },
    getProfile,
    handleBackButton,
    onSubmit
  } = props

  return (
    <React.Fragment>
      {/* Personal Info */}
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Text className='fs-20 dark-color'>{t('profileUpdate.title1')}</Text>
        </Col>
        <Col span={12}>
          <Text className="primary-color float-right cursor-pointer" type="primary" size="large" onClick={handleBackButton}><EditOutlined /> Edit</Text>
        </Col>
        <Col span={24}>
          <Avatar size={60} src={onPreviewAvatar || getProfile?.data?.profilePicUrl} />
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.name')}</Text>
            <Text className="dark-color" strong>{allValues.fullName ? allValues.fullName : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.email')}</Text>
            <Text className="dark-color" strong>{allValues.email ? allValues.email : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.noHandphone')}</Text>
            <Text className="dark-color" strong>{allValues.mobilePhone ? `+${callingCode}${allValues.mobilePhone}` : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.gender')}</Text>
            <Text className="dark-color" strong>{allValues.gender ? allValues.gender === "MALE" ? "Male" :  "Female" : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.place')}</Text>
            <Text className="dark-color" strong>{allValues.placeOfBirth ? allValues.placeOfBirth : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.date')}</Text>
            <Text className="dark-color" strong>{allValues.birthdate ? moment(allValues.birthdate, 'DD/MM/YYYY').format('DD MMM YYYY') : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.maritalStatus')}</Text>
            <Text className="dark-color" strong>
                {
                  allValues.marital ?
                  <Text>
                    {allValues.marital === 'SINGLE' && 'Single'}
                    {allValues.marital === 'MARRIED' && 'Married'}
                    {allValues.marital === 'DIVORCE' && 'Divorce'}
                    {allValues.marital === 'WIDOWED' && 'Widowed'}
                  </Text>
                  : 
                  '-'
                }
              </Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.currentLocation')}</Text>
            <Text className="dark-color" strong>{location || getProfile?.data?.currentCityName ? location || `${getProfile?.data?.currentCityName}, ${getProfile?.data?.currentCountryName}` : '-'}</Text>
          </Space>
        </Col>
      </Row>

      <Divider/>

      {/* Education */}
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Text className='fs-20 dark-color'>{t('profileUpdate.title2')}</Text>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.school')}</Text>
            <Text className="dark-color" strong>{allValues.educationName ? allValues.educationName : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.educationLevel')}</Text>
            <Text className="dark-color" strong>{educationLevelName ? educationLevelName : '-'}</Text>
          </Space>
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.fieldOfStudy')}</Text>
            <Text className="dark-color" strong>{allValues.educationFieldOfStudy ? allValues.educationFieldOfStudy : '-'}</Text>
          </Space>
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.startYear')}</Text>
            <Text className="dark-color" strong>{allValues.educationStartYear ? moment(allValues.educationStartYear, 'YYYY').format('YYYY') : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.endYear')}</Text>
            <Text className="dark-color" strong>
              {
                allValues.educationCurrent ?
                  'Present'
                : allValues.educationEndYear ? 
                  moment(allValues.educationEndYear, 'YYYY').format('YYYY') 
                : 
                  '-'
              }
              </Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.placeholderscore')}</Text>
            <Text className="dark-color" strong>{allValues.educationGpa ? allValues.educationGpa : '-'}</Text>
          </Space>
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.website')}</Text>
            <Text className="dark-color" strong>{allValues.educationWebsite ? allValues.educationWebsite: '-'}</Text>
          </Space>
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.activityAndOrganization')}</Text>
            <Text className="dark-color" strong>{allValues.educationExperience ? allValues.educationExperience : '-'}</Text>
          </Space>
        </Col>
      </Row>

      <Divider/>

      {/* Work Experience */}
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Text className='fs-20 dark-color'>{t('profileUpdate.title3')}</Text>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.jobPosition')}</Text>
            <Text className="dark-color" strong>{allValues.workTitle ? allValues.workTitle : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.company')}</Text>
            <Text className="dark-color" strong>{allValues.workCompany ? allValues.workCompany : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.jobType')}</Text>
            <Text className="dark-color" strong>
            {
              allValues.workEmploymentType ?
              <Text>
                {allValues.workEmploymentType === "FULL_TIME" && 'Full Time'}
                {allValues.workEmploymentType === "PART_TIME" && 'Part Time'}
                {allValues.workEmploymentType === "FREELANCE" && 'Freelance'}
                {allValues.workEmploymentType === "INTERNSHIP" && 'Internship'}
              </Text>
              :
              '-'
            }
            </Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.jobLocation')}</Text>
            <Text className="dark-color" strong>{workLocation ? workLocation : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.business/Sector')}</Text>
            <Text className="dark-color" strong>{businessSectorName ? businessSectorName : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.department')}</Text>
            <Text className="dark-color" strong>{allValues.workDepartment ? allValues.workDepartment : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.companyEmail')}</Text>
            <Text className="dark-color" strong>{allValues.workCompanyEmail ? allValues.workCompanyEmail : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.companyWebsite')}</Text>
            <Text className="dark-color" strong>{allValues.workWebsite ? allValues.workWebsite : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.startDate')}</Text>
            <Text className="dark-color" strong>{allValues.workStartDate ? moment(allValues.workStartDate, 'YYYY-MM').format('YYYY-MM') : '-'}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.endDate')}</Text>
            <Text className="dark-color" strong>
              {
                allValues.workCurrent ?
                  'Present'
                : allValues.workEndDate ? 
                  moment(allValues.workEndDate, 'YYYY-MM').format('YYYY-MM')
                : 
                  '-'
              }
            </Text>
          </Space>
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={0}>
            <Text className="fs-12" type="secondary">{t('profileUpdate.description')}</Text>
            <Text className="dark-color" strong>{allValues.workDescription ? allValues.workDescription : '-'}</Text>
          </Space>
        </Col>
      </Row>

      <Divider/>

      {/* Document */}
      {
        allValues?.listDocument?.length > 0 ?
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Text className='fs-20 dark-color'>{t('profileUpdate.title4')}</Text>
            </Col>
            {
              allValues?.listDocument?.map((item,i) =>
                <React.Fragment key={i}>
                  <Col span={12}>
                    <Space direction="vertical" size={0}>
                      <Text className="fs-12" type="secondary">{t('profileUpdate.documentType')}</Text>
                      <Text className="dark-color" strong>{documentTypeName[i]}</Text>
                    </Space>
                  </Col>
                  <Col span={12}>
                    <Space direction="vertical" size={0}>
                      <Text className="fs-12" type="secondary">{t('profileUpdate.documentNumber')}</Text>
                      <Text className="dark-color" strong>{item.documentNumber ? item.documentNumber : '-'}</Text>
                    </Space>
                  </Col>
                  <Col span={12}>
                    <Space direction="vertical" size={0}>
                      <Text className="fs-12" type="secondary">{t('profileUpdate.dateOfIssue')}</Text>
                      <Text className="dark-color" strong>{item.documentIssueDate ? moment(item.documentIssueDate, 'MM/YYYY').format('MM/YYYY') : '-'}</Text>
                    </Space>
                  </Col>
                  <Col span={12}>
                    <Space direction="vertical" size={0}>
                      <Text className="fs-12" type="secondary">{t('profileUpdate.expirationDate')}</Text>
                      <Text className="dark-color" strong>
                        {
                          item.documentCurrent ?
                            'Present'
                          : item.documentExpirationDate ? 
                            moment(item.documentExpirationDate, 'MM/YYYY').format('MM/YYYY')
                          : 
                            '-'
                        }
                      </Text>
                    </Space>
                  </Col>
                  <Col span={24}>
                    <Space direction="vertical" size={0}>
                      <Text className="fs-12" type="secondary">{t('profileUpdate.document')}</Text>
                      {
                        item?.documentFile?.name ? 
                          <React.Fragment>
                            <Image
                              width={100}
                              height={100}
                              src="error"
                              preview={false}
                              fallback="data:image/png;base64,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"
                            />
                            <Text className="dark-color" strong>{documentFile.name}</Text>
                          </React.Fragment>
                        : 
                          '-'
                      }
                    </Space>
                  </Col>
                  <Col span={24}>
                    <Space direction="vertical" size={0}>
                      <Text className="fs-12" type="secondary">{t('profileUpdate.remarks')}</Text>
                      <Text className="dark-color" strong>{item.documentRemark ? item.documentRemark : '-'}</Text>
                    </Space>
                  </Col>
                </React.Fragment>
              )
            }
          </Row>
        : null
      }

      <Row className='mt-32'>
        <Col span={24}>
          <Space className='float-right'>
            <CButton className="btn-save-primary" type="default" action={handleBackButton} title="kembali"/>
            <Button className="btn-save-primary" type="primary" loading={submitLoading} onClick={onSubmit}>Simpan</Button>
            {/* <CButton className="btn-save-primary" type="primary" loading={submitLoading} action={onSubmit} title="Simpan"/> */}
          </Space>
        </Col>
      </Row>
    </React.Fragment>
  )
}
